export default __webpack_public_path__ + "static/media/smart.e68a983f.png";